import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export type UDImageSize = 'sm' | 'md' | 'lg';

/** Форма: `rounded` — квадрат с радиусом `card` (по умолчанию), `circle` — круг. */
export type UDImageShape = 'rounded' | 'circle';

export const sizeMap: Record<UDImageSize, number> = {
  sm: 24,
  md: 40,
  lg: 56,
};

interface UDImageContainerProps {
  sizePx: number;
  shape: UDImageShape;
}

export const UDImageContainer = styled.div<UDImageContainerProps>`
  width: ${(props) => props.sizePx}px;
  height: ${(props) => props.sizePx}px;
  min-width: ${(props) => props.sizePx}px;
  min-height: ${(props) => props.sizePx}px;
  border-radius: ${({ theme, shape }) => (shape === 'circle' ? theme.radii.pill : theme.radii.card)};
  border: 1px solid ${theme.colors.SurfaceCultured10};
  box-sizing: border-box;
  overflow: hidden;
`;

export const UDImageElement = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
